<template>
  <div v-if="filtersData" class="b-products-filters">
    <div
      v-for="filter in filtersData"
      ref="filter-item"
      :key="filter.id"
      class="b-products-filters__item">
      <products-filter-item
        :ref="`filter-${filter.id}`"
        :pre-selected-filters="preSelectedFilters"
        :filter="filter"
        @on-change-filter="onChangeFilter" />
    </div>
  </div>
  <div v-if="filtersData" class="b-products-filters b-products-filters--mob">
    <div class="b-products-filters__item" @click="showMobMenu = true">
      {{ dictionary.buttonFilterLabel }}
      <img src="/imgs/icons/select-icon.png" alt="filter-icon" />
    </div>
    
    <div class="b-products-filters__mob-menu" :class="{ active: showMobMenu }">
      <div class="b-products-filters__mob-menu__content">
        <div class="b-products-filters__mob-menu__label">
          {{ dictionary.mobileMenuFilterLabel }}
        </div>
        <div
          v-for="filter in filtersData"
          :key="filter.id"
          class="b-products-filters__mob-menu__item">
          <Accordion :title="filter.filterLabel">
            <products-filter-item
              :ref="`mobFilter-${filter.id}`"
              :pre-selected-filters="preSelectedFilters"
              :filter="filter"
              :mobile="true"
              @on-change-filter="onChangeFilterMobile"></products-filter-item>
          </Accordion>
        </div>
        <button type="button" class="btn btn-secondary" @click="applyFilters">
          <span>{{ dictionary.mobileMenuFilterApplyLabel }}</span>
        </button>
      </div>
    </div>
  </div>
  
  <div
    v-if="selectedFilters.length"
    class="b-products-filters__selected-filters">
    <div
      v-for="item in selectedFilters"
      :key="item.id"
      class="b-products-filters__selected-filter"
      @click="clearSelected(item.id)">
      {{ item.value.label }}
      <div>x</div>
    </div>
    <span
      v-if="showClearAll"
      class="b-products-filters__selected-filters__clear"
      @click="clearAll">
      {{ dictionary.clearAllFiltersLabel }}
    </span>
  </div>
</template>

<script>
import ProductsFilterItem from './ProductsFilterItem.vue'
import Accordion from '../components/common/Accordion.vue'
import { sortBy } from 'lodash'

export default {
  components: {
    Accordion,
    ProductsFilterItem,
  },
  props: {
    preSelectedFilters: {
      required: false,
      type: Array,
      default: null,
    },
    filtersData: {
      required: true,
      type: Array,
    },
  },
  emits: ['on-change-filter'],
  data() {
    return {
      selectedFilters: [],
      showImg: false,
      iconUrl: '',
      showMobMenu: false,
    }
  },

  computed: {
    showClearAll() {
      return this.selectedFilters.length > 1
    },
  },

  mounted() {
    this.$nextTick(() => {
      // this.showOptions('01')
      // this.$refs['filter-item'][0].addEventListener('focusin', (e) => {
      //   console.log('focusout', e)
      // })
    })
  },
  methods: {
    applyFilters() {
      this.showMobMenu = !this.showMobMenu
      this.$emit('on-change-filter', this.selectedFilters)
    },

    closeOptions(id) {
      this.$refs[`filter-${id}`][0].closeOptions()
    },

    onChangeFilter(id, value) {
      this.onChangeFilterMobile(id, value)
      this.$emit('on-change-filter', this.selectedFilters)
    },

    onChangeFilterMobile(id, value) {
      const index = this.selectedFilters.findIndex((item) => item.id === id)

      if (index !== -1) {
        // Key exists, replace the value or delete key if value is empty
        if (!value) {
          this.selectedFilters.splice(index, 1)
        } else {
          this.selectedFilters[index].value = value
        }
      } else {
        // Key doesn't exist, push a new object
        this.selectedFilters.push({ id, value })
      }

      this.selectedFilters = sortBy(this.selectedFilters, [
        function (x) {
          return x.id
        },
      ])
    },

    clearSelected(id) {
      this.$refs[`filter-${id}`][0].clear()
      this.$refs[`mobFilter-${id}`][0].clear()
    },

    clearAll() {
      this.$refs['filter-01'][0].clear()
      this.$refs['filter-02'][0].clear()
      this.$refs['mobFilter-01'][0].clear()
      this.$refs['mobFilter-02'][0].clear()
    },
  },
}
</script>
